import React from 'react'

import styled from 'styled-components'

import {
  Box,
  Button,
  Flex,
  Modal,
} from 'app/components/design-system-components'
import { mediaQueries } from 'app/components/design-system-components/styles/variables'
import theme from 'app/match/applicationReportPDF/assets/theme'
import JoinSnugBanner from 'app/shared_components/join_snug_banner'
import * as gtmHelpers from 'app/utils/google-tag-manager/helpers'

const ModalFooter = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  margin-top: ${theme.space[4]}px;
  ${mediaQueries.sm} {
    flex-direction: column;
    align-items: center;
    button {
      width: 100%;
      margin-bottom: ${theme.space[3]}px;
    }
  }
`

function VerifyOrContinueAsGuestModal({
  toggleVerifyOrContinueAsGuestModal,
  toggleCompletedReferenceModal,
  toggleVerifyAccountModal,
  primaryActionConnectTeam,
  continueAsGuestAction,
  managerEmail = '',
}) {
  const primaryActionForModal = () => {
    toggleVerifyOrContinueAsGuestModal()
    primaryActionConnectTeam()
    toggleVerifyAccountModal()
  }
  const modalBody = (
    <Box fontSize={theme.fontSizes.pLarge16} mt={5}>
      <Box>Click "Complete Reference" to view and submit the reference.</Box>
      <Box mt={6} mb={5}>
        If you'd like to create a FREE Rental Reference Inbox for future
        references for yourself and your team, click "Complete Reference and
        Create Inbox"
      </Box>
      <JoinSnugBanner />
    </Box>
  )
  return (
    <Modal
      modalBody={modalBody}
      secondaryLabel="Complete Reference and Create Inbox"
      primaryLabel="Complete Reference"
      toggleModal={toggleVerifyOrContinueAsGuestModal}
      secondaryAction={() => {
        primaryActionForModal()
      }}
      primaryAction={() => continueAsGuestAction()}
      modalHeading="Start Rental Reference"
      secondaryButtonClassName={
        gtmHelpers.RR_LITE_JUNE_2023_GTM_CONTINUE_AS_GUEST
      }
      primaryButtonClassName={gtmHelpers.RR_LITE_JUNE_2023_GTM_VERIFY_BUTTON}
      secondaryButtonVariant="outlineSuccess"
      customModalFooter={true}
      modalFooter={
        <ModalFooter>
          <Button
            onClick={() => primaryActionForModal()}
            variant="outlineSuccess"
            width="50%"
            mr={3}
          >
            Complete Reference and Create Inbox
          </Button>
          <Button onClick={() => continueAsGuestAction()} width="50%">
            Complete Reference
          </Button>
        </ModalFooter>
      }
    />
  )
}

export default VerifyOrContinueAsGuestModal
